import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
import { BookOpenIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function CTASection() {
  return <section id="cta" className="py-14 md:py-24 px-4 md:px-6 relative overflow-hidden" data-id="element-122">
      <div className="absolute inset-0 bg-gradient-to-b from-navy to-gold/5 -z-20" data-id="element-123"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-gold/15 blur-[100px] rounded-full -z-10 opacity-50" data-id="element-124"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-125">
        <FadeIn data-id="element-126">
          <p className="text-base md:text-2xl text-white mb-5 md:mb-8 font-medium" data-id="element-127">
            Si estás lista para salir del modo supervivencia y empezar a dormir
            con más calma:
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-128">
          <div className="bg-navy-card/80 backdrop-blur-sm p-6 md:p-12 rounded-2xl md:rounded-3xl shadow-xl border border-navy-light mb-6 md:mb-10" data-id="element-129">
            <BookOpenIcon className="w-10 h-10 md:w-12 md:h-12 text-gold mx-auto mb-4 md:mb-6" data-id="element-130" />

            <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-4 md:mb-6 leading-tight" data-id="element-131">
              Compra ahora <br className="hidden md:block" data-id="element-132" />
              <span className="text-gold" data-id="element-133">
                "Guía del Sueño del Bebé (0 a 3 Años)"
              </span>
            </h2>

            <p className="text-sm md:text-xl text-white/70 mb-6 md:mb-8 max-w-xl mx-auto" data-id="element-134">
              y llévate también el{' '}
              <span className="font-bold text-gold" data-id="element-135">
                Planificador de Sueño del Bebé
              </span>{' '}
              para aplicar todo desde el primer día.
            </p>

            <div className="mb-6 md:mb-8" data-id="element-136">
              <div className="inline-block bg-red-500/15 text-red-400 font-medium text-xs md:text-sm px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-137">
                🔥 Oferta por tiempo limitado
              </div>

              <div className="mb-5 md:mb-6" data-id="element-138">
                <CountdownTimer data-id="element-139" />
              </div>

              <div className="flex items-center justify-center gap-3" data-id="element-140">
                <span className="text-lg md:text-2xl font-sans text-white/30 line-through" data-id="element-141">
                  $12,99
                </span>
                <span className="text-3xl md:text-5xl font-serif font-bold text-gold" data-id="element-142">
                  $6,39
                </span>
              </div>
              <p className="text-xs md:text-sm text-white/40 mt-2" data-id="element-143">
                Ahorras más del 50%
              </p>
            </div>

            <Button href="https://maternidadenequilibrio.com/cart/48914468045024:1" onClick={trackAddToCart} className="w-full sm:w-auto px-10 md:px-12 py-4 md:py-5 text-lg md:text-xl" data-id="element-144">
              Empezar hoy
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}